import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { HoursWorkspace } from '@/components/operator/hours-workspace'
import { OperatorWorkspaceRouteGate } from '@/components/operator/operator-workspace-route-gate'
import { useOperatorConfiguration } from '@/lib/operator-config/use-operator-configuration'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/availability')({
  component: HoursPage,
  staticData: {
    breadcrumbs: [{ label: 'Availability' }],
  } satisfies RouteStaticData,
})

function HoursPage() {
  const { configuration, isLoading, error, refreshAll } = useOperatorConfiguration()

  return (
    <WorkspaceRouteShell>
      <OperatorWorkspaceRouteGate
        configuration={configuration}
        isLoading={isLoading}
        error={error}
        onRetry={refreshAll}
        loadingCopy="Loading availability…"
        resourceLabel="availability"
        noOperatorTitle="Set up your business before setting availability."
        noOperatorDescription="Finish setup first so schedules, breaks, and overrides attach to your operator profile."
      >
        <HoursWorkspace configuration={configuration} onSaved={refreshAll} />
      </OperatorWorkspaceRouteGate>
    </WorkspaceRouteShell>
  )
}
